<template>
    <div class="contact-us-container">
        <div class="contact-wrapper">
            <div id="preloader" v-if="load" class="preloader"></div>
            <div class="contact-input">
                <div class="info">
                    <span class="header">Contact us</span>
                    <span class="call-to"
                        >Whether you need some support or just wanna chat. We're here to
                        help.</span
                    >
                </div>
                <div class="input-field">
                    <div class="name">
                        <label
                            for="name"
                            :class="{ 'error-label': fullNameError }"
                            class="label"
                        >
                            Full name *
                        </label>
                        <input
                            v-model="full_name"
                            name="full_name"
                            @input="validateFullName"
                            :class="{ 'error-border': fullNameError }"
                            class="input"
                            type="text"
                            id="name"
                            placeholder="Enter your full name"
                        />
                        <div class="error-msg" v-if="fullNameError">
                            <img
                                class="warning-icon"
                                src="/images/icons/warning.svg"
                                alt="warning-icon"
                            />
                            <span class="error-msg-text">
                                {{ fullNameError }}
                            </span>
                        </div>
                    </div>
                    <div class="email">
                        <label for="mail" :class="{ 'error-label': emailError }" class="label">
                            Email *
                        </label>
                        <input
                            class="input"
                            name="email"
                            type="email"
                            v-model="email"
                            @input="validateEmail"
                            :class="{ 'error-border': emailError }"
                            id="mail"
                            placeholder="Enter your email"
                        />
                        <div class="error-msg" v-if="emailError">
                            <img
                                class="warning-icon"
                                src="/images/icons/warning.svg"
                                alt="warning-icon"
                            />
                            <span class="error-msg-text">
                                {{ emailError }}
                            </span>
                        </div>
                    </div>
                    <div class="msg">
                        <label
                            :class="{ 'error-label': questionError }"
                            class="label"
                            for="text"
                        >
                            Question *
                        </label>
                        <textarea
                            type="text"
                            class="question"
                            name="question"
                            placeholder="Type your question"
                            id="text"
                            v-model="question"
                            @input="validateQuestion"
                            :class="{ 'error-border': questionError }"
                        >
                        </textarea>
                        <div class="error-msg" v-if="questionError">
                            <img
                                class="warning-icon"
                                src="/images/icons/warning.svg"
                                alt="warning-icon"
                            />
                            <span class="error-msg-text">
                                {{ questionError }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="call-to-action">
                    <button
                        class="call-btn"
                        :class="{ 'submit-button': isFormValid }"
                        @click="submitForm"
                    >
                        <span :class="{ 'call-text-success': isFormValid }" class="call-text"
                            >Send</span
                        >
                    </button>
                </div>
            </div>
        </div>
        <div class="img-wrapper">
            <div class="contact-img"></div>
        </div>
        <div v-if="showModal" class="success-modal-container">
            <div class="success-modal-content">
                <div class="modal-info">
                    <p class="title">Message Sent!</p>
                    <p class="message">
                        Thank you! Our support team will respond within 5 business days. Need
                        an answer faster? Try our FAQs.
                    </p>
                </div>
                <div class="modal-action">
                    <button @click="redirectToFAQs" class="faq-btn">Check FAQs</button>
                    <button @click="closeModal" class="close-modal-btn">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../helpers/notification'
    export default {
        name: 'ContactUs',
        data() {
            return {
                showModal: false,
                full_name: '',
                fullNameError: '',
                email: '',
                emailError: '',
                question: '',
                questionError: '',
                load: false
            }
        },
        computed: {
            isFormValid() {
                return (
                    this.fullNameError === '' &&
                    this.emailError === '' &&
                    this.questionError === '' &&
                    this.full_name !== '' &&
                    this.email !== '' &&
                    this.question !== ''
                )
            }
        },
        methods: {
            async sendMsg() {
                this.load = true
                try {
                    await axios.post('/contact-us', {
                        email: this.email,
                        full_name: this.full_name,
                        question: this.question
                    })
                    this.email = ''
                    this.full_name = ''
                    this.question = ''
                    this.showModal = true
                    this.load = false
                } catch (error) {
                    notification('error', error)
                    this.load = false
                }
            },
            validateQuestion() {
                if (this.question.trim() === '') {
                    this.questionError = 'Type your question.'
                } else {
                    this.questionError = ''
                }
            },
            validateFullName() {
                if (this.full_name.trim().split(' ').length >= 2) {
                    this.fullNameError = ''
                } else {
                    this.fullNameError = 'Enter your full name.'
                }
            },
            validateEmail() {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (this.email.trim() === '' || !emailRegex.test(this.email)) {
                    this.emailError = 'Please enter a valid email address.'
                } else {
                    this.emailError = ''
                }
            },
            submitForm() {
                if (this.isFormValid) {
                    this.sendMsg()
                }
            },
            redirectToFAQs() {
                window.location.href = '/faqs'
            },
            closeModal() {
                this.showModal = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    @media only screen and (max-width: 850px) {
        .success-modal-content {
            left: 0 !important;
        }
    }
    .contact-us-container {
        display: flex;
        align-items: center;
        background: #000;
    }
    .success-modal-container {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        background: rgba(18, 18, 18, 0.7);
        width: 100vw;
        height: 150vh;
        z-index: 5;
        backdrop-filter: blur(6px);
    }
    .success-modal-content {
        position: relative;
        top: 20%;
        left: calc(50vw - 250px);
        max-width: 620px;
        display: flex;
        flex-direction: column;
        gap: 40px;
        justify-content: center;
        align-items: center;
        padding: 40px 20px 44px 20px;
        border-radius: 16px;
        background: #262626;
    }
    .modal-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }
    .title {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.76px;
        margin-bottom: 0px;
    }
    .message {
        color: #8b8b8b;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 650;
        line-height: 125%;
        margin-bottom: 0px;
    }
    .modal-action {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 20px;
    }
    .faq-btn {
        align-self: stretch;
        background: #cdeb09;
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .close-modal-btn {
        align-self: stretch;
        background: transparent;
        border: none;
        width: 100%;
        color: #8b8b8b;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration-line: underline;
    }
    .contact-wrapper {
        display: flex;
        width: 100%;
        align-items: center;
        background: #000;
        box-shadow: 0px 24px 48px -8px rgba(0, 0, 0, 0.4), 0px 0px 1px 0px rgba(0, 0, 0, 0.6);
    }
    .contact-input {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-left: 90px;
        padding-bottom: 90px;
        margin-top: 100px;
    }
    .info {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        padding-bottom: 80px;
        gap: 16px;
    }
    .header {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .call-to {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .input-field {
        display: flex;
        flex-direction: column;
        gap: 20px;
        z-index: 1;
    }
    .label {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .input {
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 16px 16px 16px;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 125%;
        color: #dedede;
    }
    .msg {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        flex: 1 0 0;
    }
    .question {
        display: flex;
        white-space: pre-wrap;
        padding: 12px 16px 16px 16px;
        min-height: 290px;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
        align-self: stretch;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 125%;
        color: #dedede;
    }
    .name {
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 6px;
    }
    .email {
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 6px;
    }
    .call-to-action {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 32px;
    }
    .call-btn {
        display: flex;
        justify-content: center;
        flex: 1;
        border-radius: 100px;
        background: #464646;
        padding: 11px 30px 12px 30px;
        border: none;
    }
    .contact-img {
        min-width: 50vw;
        min-height: 100vh;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.08) 100%),
            url(/images/contactpic.png), lightgray -181.868px 0px / 143.826% 100% no-repeat;
        box-shadow: 99px 140px 200px -10px #000 inset, 0px -40px 200px -10px #000 inset;
    }

    .img-wrapper {
        width: 100%;
        height: 100%;
        background: #121212;
    }
    .call-text {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
    }
    .error-msg {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
    .error-msg-text {
        padding-top: 3px;
        color: #e23453;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .error-border {
        border: 1.5px solid #e23453;
    }
    .error-label {
        color: #e23453;
    }
    .submit-button {
        background-color: #ba87ff;
    }
    .call-text-success {
        color: #000;
    }
    @media only screen and (max-width: 768px) {
        .contact-us-container {
            display: flex;
            flex-direction: column;
        }
        .contact-wrapper {
            flex-direction: column;
            padding: 64px 16px 0 16px;
            background: #121212;
        }
        .contact-input {
            padding-left: 0;
            margin-top: 64px;
        }
        .input::placeholder {
            overflow: hidden;
            color: #646464;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: Instrument Sans;
            font-size: 22px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.22px;
        }
        .question {
            min-height: 160px;
        }
        .input {
            font-size: 22px;
        }
        .question::placeholder {
            overflow: hidden;
            color: #646464;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: Instrument Sans;
            font-size: 22px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.22px;
        }
        .contact-img {
            height: 375px;
            box-shadow: none;
            margin-bottom: 128px;
            background: linear-gradient(
                    0deg,
                    #121212 -17.49%,
                    rgba(18, 18, 18, 0.99) -12.49%,
                    rgba(18, 18, 18, 0.96) -7.49%,
                    rgba(18, 18, 18, 0.92) -2.49%,
                    rgba(18, 18, 18, 0.85) 2.51%,
                    rgba(18, 18, 18, 0.77) 7.51%,
                    rgba(18, 18, 18, 0.67) 12.51%,
                    rgba(18, 18, 18, 0.56) 17.51%,
                    rgba(18, 18, 18, 0.44) 22.51%,
                    rgba(18, 18, 18, 0.33) 27.51%,
                    rgba(18, 18, 18, 0.23) 32.51%,
                    rgba(18, 18, 18, 0.15) 37.51%,
                    rgba(18, 18, 18, 0.08) 42.51%,
                    rgba(18, 18, 18, 0.04) 47.51%,
                    rgba(18, 18, 18, 0.01) 52.51%,
                    rgba(18, 18, 18, 0) 57.51%
                ),
                linear-gradient(
                    180deg,
                    #121212 0%,
                    rgba(18, 18, 18, 0.99) 1.64%,
                    rgba(18, 18, 18, 0.96) 3.29%,
                    rgba(18, 18, 18, 0.92) 4.93%,
                    rgba(18, 18, 18, 0.85) 6.58%,
                    rgba(18, 18, 18, 0.77) 8.22%,
                    rgba(18, 18, 18, 0.67) 9.87%,
                    rgba(18, 18, 18, 0.56) 11.51%,
                    rgba(18, 18, 18, 0.44) 13.15%,
                    rgba(18, 18, 18, 0.33) 14.8%,
                    rgba(18, 18, 18, 0.23) 16.44%,
                    rgba(18, 18, 18, 0.15) 18.09%,
                    rgba(18, 18, 18, 0.08) 19.73%,
                    rgba(18, 18, 18, 0.04) 21.38%,
                    rgba(18, 18, 18, 0.01) 23.02%,
                    rgba(18, 18, 18, 0) 24.66%
                ),
                url(/images/contactpic.png), lightgray -156.516px 0px / 177.961% 100% no-repeat;
        }
    }
</style>
